/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_YoutubeInputs */

const en_us2_exercise_sheet_youtube = /** @type {(inputs: Exercise_Sheet_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch it performed`)
};

const pt_br2_exercise_sheet_youtube = /** @type {(inputs: Exercise_Sheet_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver execução real`)
};

const es_419_exercise_sheet_youtube = /** @type {(inputs: Exercise_Sheet_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver cómo se hace`)
};

const pt_pt2_exercise_sheet_youtube = /** @type {(inputs: Exercise_Sheet_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver a execução real`)
};

const fr_fr2_exercise_sheet_youtube = /** @type {(inputs: Exercise_Sheet_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir l'exécution`)
};

const de_de2_exercise_sheet_youtube = /** @type {(inputs: Exercise_Sheet_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausführung ansehen`)
};

const it_it2_exercise_sheet_youtube = /** @type {(inputs: Exercise_Sheet_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda l'esecuzione`)
};

/**
* | output |
* | --- |
* | "Watch it performed" |
*
* @param {Exercise_Sheet_YoutubeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_youtube = /** @type {((inputs?: Exercise_Sheet_YoutubeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_YoutubeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_youtube(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_youtube(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_youtube(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_youtube(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_youtube(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_youtube(inputs)
	return en_us2_exercise_sheet_youtube(inputs)
});
export { exercise_sheet_youtube as "exercise-sheet.youtube" }